export const groupDigits = (value: string, separator: string): string =>
	value.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
